import { connectHook } from 'app/common/components/connect-hook';
import ObjectField from './object-field.js';
import { useObjectField } from './object-field-hook.js';

export default connectHook(ObjectField, useObjectField);
